import Vue from 'vue'
import Router from 'vue-router'
// import VueAnalytics from 'vue-analytics'

import LangWrapper from './views/LangWrapper'
import Menu from './views/Menu'
import Home from './views/Home'
import Azienda from './views/Azienda'
import Impianto from './views/Impianto'
import ComeFunziona from './views/ComeFunziona'
import ComeFunzionaSub from './views/ComeFunzionaSub'
import Vantaggi from './views/Vantaggi'
import Contatti from './views/Contatti'
import Biochar from './views/Biochar'
import RichiestaContatti from './views/RichiestaContatti'
import RichiestaBrochure from './views/RichiestaBrochure'
// import DoveSiamo from './views/DoveSiamo'
import CondizioniGenerali from './views/CondizioniGenerali'
import CookiePolicy from './views/CookiePolicy'
import Success from './views/Success'
import Failure from './views/Failure'
import BrochureSuccess from './views/BrochureSuccess'
import BrochureFailure from './views/BrochureFailure'
import NotFound from './views/NotFound'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    if (from.name === to.name && to.hash) return

    if (from.name !== to.name && to.hash) return { selector: to.hash }

    if (savedPosition) return { savedPosition }

    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      component: LangWrapper,
      props: () => ({
        lang: 'it'
      }),
      children: [
        {
          name: 'it-menu',
          path: 'menu/',
          component: Menu,
          meta: {
            pageName: 'menu'
          },
          pathToRegexpOptions: { strict: true }
        },
        {
          name: 'it-home',
          path: '',
          component: Home,
          meta: {
            pageName: 'homepage'
          },
          pathToRegexpOptions: { strict: true }
        },
        {
          name: 'it-azienda',
          path: 'azienda/',
          component: Azienda,
          meta: {
            pageName: 'company'
          },
          pathToRegexpOptions: { strict: true }
        },
        {
          name: 'it-impianto',
          path: 'impianto/',
          component: Impianto,
          meta: {
            pageName: 'impianto'
          },
          pathToRegexpOptions: { strict: true }
        },
        {
          name: 'it-come-funziona',
          path: 'come-funziona/',
          component: ComeFunziona,
          meta: {
            pageName: 'processings'
          },
          pathToRegexpOptions: { strict: true }
        },
        {
          name: 'it-come-funziona-sub',
          path: 'come-funziona/:type/',
          component: ComeFunzionaSub,
          props: ({ params }) => ({ type: params.type }),
          meta: {
            pageName: 'processings/list'
          },
          pathToRegexpOptions: { strict: true }
        },
        {
          name: 'it-vantaggi',
          path: 'vantaggi/',
          component: Vantaggi,
          props: ({ hash }) => ({ hash }),
          meta: {
            pageName: 'vantaggi'
          },
          pathToRegexpOptions: { strict: true }
        },
        {
          name: 'it-biochar',
          path: 'biochar/',
          component: Biochar,
          props: ({ hash }) => ({ hash }),
          meta: {
            pageName: 'biochar'
          },
          pathToRegexpOptions: { strict: true }
        },
        {
          name: 'it-contatti',
          path: 'contatti/',
          component: Contatti,
          meta: {
            pageName: 'contacts'
          },
          pathToRegexpOptions: { strict: true }
        },
        /*
        {
          name: 'it-dove-siamo',
          path: 'dove-siamo/',
          component: DoveSiamo,
          meta: {
            pageName: 'location'
          },
          pathToRegexpOptions: { strict: true }
        },
        */
        {
          name: 'it-richiesta-contatti',
          path: 'richiesta-informazioni/',
          component: RichiestaContatti,
          meta: {
            pageName: 'contacts-request'
          },
          pathToRegexpOptions: { strict: true }
        },
        {
          name: 'it-richiesta-brochure',
          path: 'richiesta-brochure/',
          component: RichiestaBrochure,
          meta: {
            pageName: 'brochure-request'
          },
          pathToRegexpOptions: { strict: true }
        },
        {
          name: 'it-condizioni-generali',
          path: 'condizioni-generali/',
          component: CondizioniGenerali,
          meta: {
            pageName: 'privacy-policy'
          },
          pathToRegexpOptions: { strict: true }
        },
        {
          name: 'it-cookie-policy',
          path: 'privacy-cookie-policy/',
          component: CookiePolicy,
          meta: {
            pageName: 'privacy-cookie-policy'
          },
          pathToRegexpOptions: { strict: true }
        },
        {
          name: 'it-success',
          path: 'richiesta-informazioni/success/',
          component: Success,
          meta: {
            pageName: 'success'
          },
          pathToRegexpOptions: { strict: true }
        },
        {
          name: 'it-failure',
          path: 'richiesta-informazioni/failure/',
          component: Failure,
          meta: {
            pageName: 'failure'
          },
          pathToRegexpOptions: { strict: true }
        },
        {
          name: 'it-brochure-success',
          path: 'richiesta-brochure/success/',
          component: BrochureSuccess,
          meta: {
            pageName: 'brochure-success'
          },
          pathToRegexpOptions: { strict: true }
        },
        {
          name: 'it-brochure-failure',
          path: 'richiesta-brochure/failure/',
          component: BrochureFailure,
          meta: {
            pageName: 'brochure-failure'
          },
          pathToRegexpOptions: { strict: true }
        }
        /* {
          path: '*',
          name: 'pagina-non-trovata/',
          component: NotFound,
          meta: {
            pageName: 'not-found'
          },
          pathToRegexpOptions: { strict: true }
        }, */
      ]
    },
    {
      path: '/en',
      component: LangWrapper,
      props: () => ({
        lang: 'en'
      }),
      children: [
        {
          name: 'en-menu',
          path: 'menu/',
          component: Menu,
          meta: {
            pageName: 'menu'
          },
          pathToRegexpOptions: { strict: true }
        },
        {
          name: 'en-home',
          path: '',
          component: Home,
          meta: {
            pageName: 'homepage'
          },
          pathToRegexpOptions: { strict: true }
        },
        {
          name: 'en-azienda',
          path: 'company/',
          component: Azienda,
          meta: {
            pageName: 'company'
          },
          pathToRegexpOptions: { strict: true }
        },
        {
          name: 'en-impianto',
          path: 'plant/',
          component: Impianto,
          meta: {
            pageName: 'plant'
          },
          pathToRegexpOptions: { strict: true }
        },
        {
          name: 'en-come-funziona',
          path: 'works/',
          component: ComeFunziona,
          meta: {
            pageName: 'processings'
          },
          pathToRegexpOptions: { strict: true }
        },
        {
          name: 'en-come-funziona-sub',
          path: 'works/:type/',
          component: ComeFunzionaSub,
          props: ({ params }) => ({ type: params.type }),
          meta: {
            pageName: 'processings/list'
          },
          pathToRegexpOptions: { strict: true }
        },
        {
          name: 'en-vantaggi',
          path: 'advantages/',
          component: Vantaggi,
          props: ({ hash }) => ({ hash }),
          meta: {
            pageName: 'advantages'
          },
          pathToRegexpOptions: { strict: true }
        },
        {
          name: 'en-biochar',
          path: 'biochar/',
          component: Biochar,
          props: ({ hash }) => ({ hash }),
          meta: {
            pageName: 'biochar'
          },
          pathToRegexpOptions: { strict: true }
        },
        {
          name: 'en-contatti',
          path: 'contacts/',
          component: Contatti,
          meta: {
            pageName: 'contacts'
          },
          pathToRegexpOptions: { strict: true }
        },
        /*
        {
          name: 'en-dove-siamo',
          path: 'dove-siamo/',
          component: DoveSiamo,
          meta: {
            pageName: 'location'
          },
          pathToRegexpOptions: { strict: true }
        },
        */
        {
          name: 'en-richiesta-contatti',
          path: 'richiesta-informazioni/',
          component: RichiestaContatti,
          meta: {
            pageName: 'contacts-request'
          },
          pathToRegexpOptions: { strict: true }
        },
        {
          name: 'en-richiesta-brochure',
          path: 'richiesta-brochure/',
          component: RichiestaBrochure,
          meta: {
            pageName: 'brochure-request'
          },
          pathToRegexpOptions: { strict: true }
        },
        {
          name: 'en-condizioni-generali',
          path: 'condizioni-generali/',
          component: CondizioniGenerali,
          meta: {
            pageName: 'privacy-policy'
          },
          pathToRegexpOptions: { strict: true }
        },
        {
          name: 'en-cookie-policy',
          path: 'privacy-cookie-policy/',
          component: CookiePolicy,
          meta: {
            pageName: 'privacy-cookie-policy'
          },
          pathToRegexpOptions: { strict: true }
        },
        {
          name: 'en-success',
          path: 'richiesta-informazioni/success/',
          component: Success,
          meta: {
            pageName: 'success'
          },
          pathToRegexpOptions: { strict: true }
        },
        {
          name: 'en-failure',
          path: 'richiesta-informazioni/failure/',
          component: Failure,
          meta: {
            pageName: 'failure'
          },
          pathToRegexpOptions: { strict: true }
        },
        {
          name: 'en-brochure-success',
          path: 'richiesta-brochure/success/',
          component: BrochureSuccess,
          meta: {
            pageName: 'brochure-success'
          },
          pathToRegexpOptions: { strict: true }
        },
        {
          name: 'en-brochure-failure',
          path: 'richiesta-brochure/failure/',
          component: BrochureFailure,
          meta: {
            pageName: 'brochure-failure'
          },
          pathToRegexpOptions: { strict: true }
        },
        {
          path: '*',
          name: 'pagina-non-trovata/',
          component: NotFound,
          meta: {
            pageName: 'not-found'
          },
          pathToRegexpOptions: { strict: true }
        }
      ]
    },
    {
      path: '*',
      component: LangWrapper,
      props: () => ({
        lang: 'it'
      }),
      children: [
        {
          path: '*',
          name: 'pagina-non-trovata/',
          component: NotFound,
          meta: {
            pageName: 'not-found'
          },
          pathToRegexpOptions: { strict: true }
        }
      ]
    }
  ]
})

/* Vue.use(VueAnalytics, {
  id: 'UA-#######-#',
  disabled: true,
  debug: {
    enabled: process.env.NODE_ENV === 'development',
    trace: process.env.NODE_ENV === 'production',
    sendHitTask: process.env.NODE_ENV === 'production'
  }
}) */

export default router
